import ajax from "../assets/uilt/ajax";

let sanctionnedCountry = {
  // List of sanctionnedCountry

  /**sanctionnedCountryById */
  getSanctionnedCountryById: req => {
    return ajax.get({
      url: "/back/sanctionnedCountry/get-country-by-id",
      param: req.param,
      success: req.success
    });
  },

  /**sanctionnedCountryPage */
  getSanctionnedCountryPage: req => {
    return ajax.get({
      url: "/back/sanctionnedCountry/get-country-page",
      param: req.param,
      success: req.success
    });
  },

  /**sanctionnedCountryApply*/
  addSanctionnedCountryApply: req => {
    return ajax.post({
      url: "/back/sanctionnedCountry/add-countryApply",
      param: req.param,
      success: req.success
    });
  },
  /**审核渠道充值、提现 */
  disposeSanctionnedCountryApply: req => {
    return ajax.post({
      url: "/back/sanctionnedCountry/dispose-countryApply",
      param: req.param,
      success: req.success
    });
  }

  /**sanctionnedCountry excel*/
  //wantedPersonDetailedExport: "/back/wanted/wanted-detailed-export",
};

export default sanctionnedCountry;
